(function () {
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function onIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 1800 });
    } else {
      window.setTimeout(callback, 900);
    }
  }

  function getHandleFromCard(card) {
    var link = card.querySelector('.product-item__title[href], .product-item__image-wrapper[href]');

    if (!link) {
      return null;
    }

    var path = new URL(link.getAttribute('href'), window.location.href).pathname;
    var productIndex = path.indexOf('/products/');

    if (productIndex === -1) {
      return null;
    }

    return path.slice(productIndex + 10).split('/')[0];
  }

  function getFirstAvailableVariant(product) {
    if (!product || !Array.isArray(product.variants)) {
      return null;
    }

    return product.variants.find(function (variant) {
      return variant.available;
    }) || product.variants[0];
  }

  function updateCartCount(count) {
    document.querySelectorAll('.header__cart-count, .cart-count, [data-cart-count]').forEach(function (element) {
      element.textContent = count;
      element.setAttribute('aria-hidden', 'false');
    });
  }

  function attachFallbackSubmit(form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var button = event.submitter || form.querySelector('button[type="submit"]');
      var originalText = button ? button.textContent : '';

      if (button) {
        button.disabled = true;
        button.textContent = 'Adicionando';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        return fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));

        if (button) {
          button.textContent = 'Adicionado';
          window.setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1600);
        }
      }).catch(function () {
        form.submit();
      });
    });
  }

  function createActions(card, product, variant) {
    var target = card.querySelector('.product-item__info');

    if (!target || !variant || card.querySelector('.tdl-product-card-actions')) {
      return;
    }

    var title = String(product.title || '').replace(/"/g, '&quot;');
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.className = 'product-item__action-list tdl-product-card-actions';
    form.setAttribute('data-tdl-fallback-card-actions', 'true');

    form.innerHTML = [
      '<input type="hidden" name="quantity" value="1">',
      '<input type="hidden" name="id" value="' + variant.id + '">',
      '<button type="submit" class="product-item__action-button tdl-product-card-actions__add button button--small button--primary" aria-label="Adicionar ' + title + ' ao carrinho"><span class="tdl-product-card-actions__add-icon" aria-hidden="true"><svg viewBox="0 0 27 24" focusable="false" role="presentation"><path d="M0 1h5l4.2 13.4h11.6L25 5H7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="10" cy="21" r="2" fill="currentColor"/><circle cx="21" cy="21" r="2" fill="currentColor"/></svg></span><span class="tdl-product-card-actions__add-label">Adicionar ao carrinho</span></button>'
    ].join('');

    attachFallbackSubmit(form);
    target.appendChild(form);
  }

  onReady(function () {
    onIdle(function () {
      var productCache = {};
      var cards = Array.prototype.slice.call(document.querySelectorAll('.product-item')).filter(function (card) {
        return !card.querySelector('.tdl-product-card-actions');
      });

      if (!cards.length) {
        return;
      }

      cards.slice(0, 36).forEach(function (card) {
        var handle = getHandleFromCard(card);

        if (!handle) {
          return;
        }

        productCache[handle] = productCache[handle] || fetch('/products/' + handle + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }).then(function (response) {
          return response.ok ? response.json() : null;
        }).catch(function () {
          return null;
        });

        productCache[handle].then(function (product) {
          var variant = getFirstAvailableVariant(product);

          if (variant && variant.available !== false) {
            createActions(card, product, variant);
          }
        });
      });
    });
  });
})();
